import { render, staticRenderFns } from "./Credit-card.vue?vue&type=template&id=1879cab4"
import script from "./Credit-card.vue?vue&type=script&lang=js"
export * from "./Credit-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports